import React, { useState } from 'react';
import { Button, Box, Tabs, Tab, Divider } from '@mui/material';
import './ScheduleOverview.css'; // External CSS file
import { CiClock2 } from "react-icons/ci";
import { LuMapPin } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';

const tabValueStyle = {
    minHeight: 'auto',
    '& .MuiTab-root': {
        textTransform: 'none',
        minHeight: 'auto',
        padding: '6px 16px',
        borderRadius: '8px',
        color: '#5c6370',
        fontWeight: 500,
        margin: 0.5,
        border: '1px solid #e0e0e0',
        marginY: 2,
        '&.Mui-selected': {
            backgroundColor: '#567C09',
            color: '#fff',
        },
    },
}

const ScheduleOverview = ({ data }) => {

    const navigate = useNavigate()
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    // FOR SET SCHEDULE DATA 
    const scheduleMap = {
        0: data?.allSchedules,
        1: data?.newSchedule,
        2: data?.inprogressSchedule,
        3: data?.completedSchedule
    };

    const scheduleData = scheduleMap[tabValue] || [];


    const handleNavigatetoScheduleOverview = (scheduleId) => {
        navigate(`/worksites/schedule/${scheduleId}`)

    }

    return (
        <Box className="schedule-overview-container" >
            <span className="schedule-overview-title">Schedule Overview</span>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                TabIndicatorProps={{ style: { display: 'none' } }}
                sx={tabValueStyle}
            >
                <Tab label="All" />
                <Tab label="Future Schedules" />
                <Tab label="In Progress" />
                <Tab label="Completed" />
            </Tabs>

            <Box className="project-list">
                <>
                    {scheduleData?.length > 0 ? (
                        scheduleData?.map((schedule, idx) => (
                            <React.Fragment key={idx}>
                                <div className="project-item">
                                    <Box className="project-details">
                                        <div className="project-header">
                                            <span className="project-title">
                                                {` ${schedule?.scheduleCode || `N/A`}`}
                                            </span>
                                            <div>
                                                <span
                                                    className={`project_status_section ${schedule?.status === "New"
                                                        ? 'project_status_new'
                                                        : schedule?.status === "Completed"
                                                            ? 'project_status_completed'
                                                            : schedule?.status === "On Hold"
                                                                ? 'project_status_hold'
                                                                : 'project_status_inprogress'
                                                        }`}
                                                >
                                                    {schedule?.status}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="project-meta">
                                            <span className="project-meta-item">
                                                <CiClock2 /> {schedule?.startDate || `N/A`} - {schedule?.endDate || `N/A`}
                                            </span>
                                            <span className="project-meta-item">
                                                <LuMapPin /> {schedule?.siteName || `N/A`}
                                            </span>
                                        </div>
                                    </Box>
                                    <button onClick={() => handleNavigatetoScheduleOverview(schedule?.scheduleID)} className="view-details-btn">View Details</button>
                                </div>
                                <Divider />
                            </React.Fragment>
                        ))
                    ) : (
                        <p className="no-data-message">No records found</p>
                    )}
                </>
            </Box>
        </Box>
    );
};

export default ScheduleOverview;
